export const CHAT_EVENT = "streaming-chat-event";
export const BAN_LIST = "streaming-banlist";
